module.exports = {"data":{"allMarkdownRemark":null},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/projects.json
// module id = 439
// module chunks = 97786326051841